<template>
  <v-card class="product" @click="toDetail">
    <v-img class="product-image white--text" :src="src" />
    <div class="product-content">
      <v-chip
        class="product-course"
        :color="courseTab"
        label
        text-color="white"
      >
        {{ course }}
      </v-chip>
      <div class="product-title">{{ title | omittedText(15) }}</div>
      <div class="product-explain">
        {{ explaination | omittedText(40) }}
      </div>
    </div>
  </v-card>
</template>

<script>
import { isMobile } from "@/lib/functions.js"

export default {
  name: "Card",
  props: {
    id: String,
    src: String,
    course: String,
    title: String,
    tags: Array,
    explaination: String,
  },
  computed: {
    courseTab: function() {
      switch (this.course) {
        case "iPhoneアプリ":
          return "#F6982A"
        case "Gameアプリ":
          return "#52B1E8"
        case "Webサービス":
          return "#E8606A"
        case "WebExpert":
          return "#B23B61"
        case "VideoEditor":
          return "#C368ED"
        case "UIUX":
          return "#1CD2AB"
        case "AI":
          return "#BCA820"

        default:
          return 0
      }
    },
    isMobile: function() {
      return isMobile()
    },
  },
  filters: {
    omittedText(text, textCount) {
      if (window.innerWidth >= 1024) {
        return text
      } else {
        return text.length > textCount ? text.slice(0, textCount) + "…" : text
      }
    },
  },
  methods: {
    toDetail: function() {
      this.$router.push({ path: `/CardDetail/${this.id}` })
    },
  },
}
</script>

<style lang="scss">
.product {
  display: flex;
  flex-direction: column;
  height: auto;
  border-radius: 0.8rem;
  box-shadow: 0px 0px 20px #3c3c3c21 !important;
  &-image {
    width: 100%;
    height: calc(30vw * 0.66);
  }

  &-content {
    flex: 1 0 10rem;
    padding: 1.8rem;
  }

  &-course {
    margin-bottom: 0.5rem;
    & > span {
      font-weight: 600;
      color: white;
      text-align: center;
    }
  }

  &-title {
    margin-bottom: 0.5rem;
    font-size: 1em;
    font-weight: 700;
  }

  &-explain {
    font-size: 0.7em;
    font-weight: 100;
  }
}

@media screen and (max-width: 1024px) {
  .product {
    box-shadow: 0px 0px 15px #3c3c3c21 !important;
    &-content {
      padding: 1rem;
    }
  }
}

@media screen and (max-width: 960px) {
  .product {
    &-image {
      height: calc(50vw * 0.66);
    }
  }
}
@media screen and (min-width: 1600px) {
  .product {
    &-image {
      height: calc(25vw * 0.66);
    }
  }
}
</style>
